import { FC } from 'react';
import { Skeleton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { QcsTooltip } from '../../common/basic/QcsTooltip';
import { DurationCell, DurationCellLabel, DurationCellValue, DurationPair, DurationRoot, KpiInfoIcon } from './KpiTileStyles';

interface Props {
  avg: string;
  median: string;
  loading?: boolean;
}

export const KpiDurationTile: FC<Props> = ({ avg, median, loading }) => {
  const { t } = useTranslation();

  return (
    <DurationRoot>
      {loading ? (
        <Skeleton variant="text" width="80%" height={28} />
      ) : (
        <DurationPair>
          <DurationCell>
            <DurationCellLabel>
              {t('analytics.kpi.avgDuration')}
              <QcsTooltip title={t('analytics.kpi.tooltip.avgDuration')} placement="top">
                <KpiInfoIcon>
                  <InfoOutlinedIcon />
                </KpiInfoIcon>
              </QcsTooltip>
            </DurationCellLabel>
            <DurationCellValue>{avg}</DurationCellValue>
          </DurationCell>
          <DurationCell>
            <DurationCellLabel>
              {t('analytics.kpi.medianDuration')}
              <QcsTooltip title={t('analytics.kpi.tooltip.medianDuration')} placement="top">
                <KpiInfoIcon>
                  <InfoOutlinedIcon />
                </KpiInfoIcon>
              </QcsTooltip>
            </DurationCellLabel>
            <DurationCellValue>{median}</DurationCellValue>
          </DurationCell>
        </DurationPair>
      )}
    </DurationRoot>
  );
};
